import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0.5 15 15">
    <path
      paintOrder="stroke fill markers"
      fillRule="evenodd"
      d="M7.875 7.125h5.688l-2.188-2.188L14 2.312 12.687 1l-2.625 2.625-2.187-2.188v5.688zm0 1.75v5.687l2.187-2.187L12.687 15 14 13.687l-2.625-2.625 2.188-2.187H7.875zm-1.75 0H.437l2.188 2.187L0 13.687 1.313 15l2.624-2.625 2.188 2.187V8.875zm0-1.75V1.437L3.937 3.625 1.313 1 0 2.312l2.625 2.625L.437 7.125h5.688z"
    />
  </SvgIcon>
);

export default Icon;
